"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMercadopago = void 0;
var v1_1 = __importDefault(require("./v1"));
var v2_1 = __importDefault(require("./v2"));
var useMercadopago = { v1: v1_1.default, v2: v2_1.default };
exports.useMercadopago = useMercadopago;
//# sourceMappingURL=index.js.map